'use client'
import { MFADeviceType } from '@dynamic-labs/sdk-api-core';

const getMfaOptions = (isInitialSetup) => {
    const mfaOptions = [
        {
            Icon: undefined,
            descriptionKey: 'dyn_mfa.choose_device_view.authenticator_app_description',
            labelKey: 'dyn_mfa.choose_device_view.authenticator_app',
            type: MFADeviceType.Totp,
        },
    ];
    if (!isInitialSetup) {
        const backupCodeOption = {
            Icon: undefined,
            descriptionKey: 'dyn_mfa.choose_device_view.backup_code_description',
            labelKey: 'dyn_mfa.choose_device_view.backup_code',
            type: 'backupCode',
        };
        mfaOptions.push(backupCodeOption);
    }
    return mfaOptions;
};

export { getMfaOptions };
